import SectionHeading from '@/pages/home/components/SectionHeading';
import { reliabilityDimensions } from '@/mocks/home';

export default function ReliabilitySection() {
  return (
    <section id="reliability" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="可靠性分析"
          title="神马影院靠谱吗？六个维度逐项看"
          desc="“靠谱”不是一个是非题。我们把可靠性拆成六个可观察的维度，用相对评分的方式呈现，帮你更直观地感受它偏弱的地方在哪里。"
        />

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {reliabilityDimensions.map((d) => (
              <div key={d.label} className="p-5 rounded-lg bg-background-50 border border-background-200">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-heading font-semibold text-foreground-950 text-sm">{d.label}</h3>
                  <span
                    className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                      d.score < 40
                        ? 'bg-primary-100 text-primary-700'
                        : d.score < 55
                        ? 'bg-secondary-100 text-secondary-800'
                        : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    {d.value}
                  </span>
                </div>
                <div className="h-1.5 w-full rounded-full bg-background-200 overflow-hidden mb-3">
                  <div
                    className="h-full rounded-full bg-primary-500"
                    style={{ width: `${d.score}%` }}
                  ></div>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{d.note}</p>
              </div>
            ))}
          </div>

          <aside className="rounded-lg bg-foreground-950 text-background-50 p-6 flex flex-col">
            <span className="text-xs text-background-300 mb-3 flex items-center gap-2">
              <i className="ri-file-info-line"></i>
              为什么容易显得“不靠谱”
            </span>
            <ul className="space-y-4 text-sm leading-relaxed text-background-200">
              <li className="flex gap-3">
                <i className="ri-close-circle-line text-primary-300 mt-0.5"></i>
                缺少可核实的运营主体和备案信息，出问题难追责。
              </li>
              <li className="flex gap-3">
                <i className="ri-close-circle-line text-primary-300 mt-0.5"></i>
                域名和入口频繁更换，稳定性和长期可用性差。
              </li>
              <li className="flex gap-3">
                <i className="ri-close-circle-line text-primary-300 mt-0.5"></i>
                以广告、导流、会员充值变现，用户权益优先级靠后。
              </li>
              <li className="flex gap-3">
                <i className="ri-close-circle-line text-primary-300 mt-0.5"></i>
                片源未经授权，内容随时可能下架或无法播放。
              </li>
            </ul>
            <div className="mt-6 pt-5 border-t border-foreground-800 text-xs text-background-300 leading-relaxed">
              评分仅为基于普遍情况的相对参考，用于帮助理解风险分布，并非对任何具体站点的精确测量。
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}